import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	standupNonfinal: {
		id: 'standups.standup-nonfinal',
		defaultMessage: 'Stand-up',
		description: 'The heading text for the standup panel',
	},
	closeLabelNonFinal: {
		id: 'standups.close-label-nonfinal',
		defaultMessage: 'Close',
		description: 'Text for the accessibility label in the icon to close the standup panel',
	},
});
